class ApiError extends Error {
  status?: number;
  data?: unknown;
  constructor(message: string, status?: number, data?: unknown) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.data = data;
  }
}

class DateError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'DateError';
  }
}

class OCRError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'OCRError';
  }
}

export { ApiError, DateError, OCRError };
